import React, { useEffect, useRef, useState } from 'react'
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as d from "../../../reducers/domainReducer";
import { getFirstName } from "../../../helpers/formatting";
import { Link, Icon, PillButton, Typography } from "../../ecosystem"
import useCarouselWidth from "./hooks/useCarouselWidth";
import ProxySelectorSlick from './ProxySelectorSlick';

const ProxySelectorCarousel = ({
    activeTab,
    allTab,
    userList,
    primaryUser,
    currentMyChartUser,
    handleChangeUser,
    isShowAllUsers
}) => {

    const sliderRef = useRef(null);
    const [currentUser, setCurrentUser] = useState(null);
    const sliderContainerRef = useRef(null);
    let { carouselWidth, proxyListWidth } = useCarouselWidth(sliderContainerRef, userList);

    useEffect(() => {
        updateCarouselActiveTabUpdate();
    }, [isShowAllUsers, activeTab]);

    useEffect(() => {
        if (currentMyChartUser && (currentUser === null || (currentUser && currentMyChartUser && currentUser.displayName !== currentMyChartUser.displayName))) {
            updateCarouselActiveTabUpdate();
            setCurrentUser(currentMyChartUser);
        }
    }, [currentMyChartUser]);

    const updateCarouselActiveTabUpdate = () => {
        if (isShowAllUsers) {
            if (sliderRef && sliderRef.current) {
                sliderRef.current.slickGoTo(0);
            }
        } else {
            if (userList && userList.length > 0) {
                updateSelectionIndex();
            }
        }
    }

    const updateSelectionIndex = () => {
        const selectedUserIndex = userList.findIndex((user) => user.displayName === currentMyChartUser.displayName);
        if (sliderRef && sliderRef.current) {
            sliderRef.current.slickGoTo(selectedUserIndex);
        }
    }

    const getProxyListTooShort = () => {
        if (proxyListWidth > 0) {
            return proxyListWidth < carouselWidth
        } else {
            return false;
        }
    }

    const manageProxyMgmt = (
        <div className="proxy-carousel__add-btn">
            <Link
                to={{ pathname: '/proxymanagement' }}
            >
                <Icon
                    name="new-patient"
                    size="medium"
                />
            </Link>
        </div>);

    const renderUsers = () => {
        const carouselList = userList.map((user, index) => (
            //<div style={{ width: user && user.displayName && getFirstName(user.displayName).length > 0 ? `${(getFirstName(user.displayName).length * 11) + 16}px` : "100%" }} key={"WebUserPxy_" + index}>
            <div key={"WebUserPxy_" + index} className={`proxy-slick-item-${index}`}>
                <div className={`proxy-slick-heading ${activeTab === user.displayName ? "active-user" : ""}`}
                    key={"WebHeroPxyItem_" + index}>
                    <Link
                        as={<button type="button"></button>}
                        onClick={e => {
                            handleChangeUser(user, primaryUser.displayName === user.displayName);
                        }}
                        typographyType="body-02"
                        decorator={activeTab === user.displayName || activeTab === allTab ? `always` : 'none'}
                    >
                        <Typography
                            type="body-02"
                            color={activeTab === user.displayName || activeTab === allTab ? "" : '$color-primary-a2'}
                        >
                            {getFirstName(user.displayName)}
                        </Typography>
                        <div>{activeTab === user.displayName && <div className="divider-underline" />}</div>
                    </Link>
                </div>
            </div>
        ))

        return carouselList;
    };

    const SlickCustomButton = ({ currentSlide, slideCount, children, ...props }) => (
        <button type="button" {...props}>{children}</button>
    );

    const settings = {
        prevArrow: (
            <SlickCustomButton>
                <Icon
                    color="$color-primary-a2"
                    name="chevron-left"
                    size="medium" />
            </SlickCustomButton>
        ),
        nextArrow: (
            <SlickCustomButton>
                <Icon
                    color="$color-primary-a2"
                    name="chevron-right"
                    size="medium" />
            </SlickCustomButton>
        ),
        dots: false,
        autoplay: false,
        infinite: getProxyListTooShort() ? false : true,
        centerMode: false,
        slidesToShow: getProxyListTooShort() ? (userList ? userList.length : 3) : 1,
        slidesToScroll: 2,
        swipeToSlide: true,
        variableWidth: true
    }

    return (
        <div className={"proxy-selector-carousel" + (getProxyListTooShort() ? ' carousel-too-short' : '')} ref={sliderContainerRef}>
            <div className="proxy-icon-container">
                <PillButton
                    label={"All"}
                    selected={activeTab === allTab}
                    icon={"proxy"}
                    onClick={e => handleChangeUser(allTab, true)}
                />
            </div>
            <div className={`proxy-slick`}
                style={{ maxWidth: proxyListWidth && proxyListWidth > 0 ? proxyListWidth : (carouselWidth && carouselWidth > 0 ? carouselWidth : '') }}
            >
                <ProxySelectorSlick sliderRef={sliderRef} settings={settings}>
                    {renderUsers()}
                </ProxySelectorSlick>
            </div>
            {manageProxyMgmt}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        isShowAllUsers: state.dashboard.isShowAllUsers,
    };
};

export default withRouter(connect(mapStateToProps, null)(ProxySelectorCarousel));

